import { EventEmitter } from "./EventEmitter";
import { LOG_LEVEL } from "../constants";
export class EventLogger extends EventEmitter {
  static logEntry(level, message, payload) {
    if (typeof message === "object") {
      payload = message;
      message = payload.message;
    }

    return {
      level,
      message,
      payload,
      timestamp: Date.now()
    };
  }

  log(level, message, payload) {
    this.emit("log", EventLogger.logEntry(level, message, payload));
  }

  info(message, payload) {
    return this.log(LOG_LEVEL.INFO, message, payload);
  }

  success(message, payload) {
    return this.log(LOG_LEVEL.SUCCESS, message, payload);
  }

  warn(message, payload) {
    return this.log(LOG_LEVEL.WARNING, message, payload);
  }

  error(message, payload) {
    return this.log(LOG_LEVEL.ERROR, message, payload);
  }

}